// Règles de visibilité et d'activation du menu latéral : fonctions pures.
//
// Les entrées viennent de sidenavItems.js, une liste plate où une entrée
// rattachée à un groupe porte `group` (clé de `groups`). Le menu les présente
// comme l'ancienne Sidenav : les entrées simples d'abord, puis les groupes dans
// l'ordre de `groups`.
//
// Une entrée est masquée :
// - si `visibleIf(user)` est faux (ex. « Jobs échoués », réservé aux comptes
//   10positif) ;
// - si son privilège `dataPriv` fait partie des privilèges retirés au rôle
//   (`privilegesOff` de roles/mine). C'est la règle de RoleStyle, qui masque
//   aussi ces entrées en CSS via [data-priv] ; le filtrage en JavaScript évite
//   en plus qu'un volet, une infobulle ou un groupe vide reste affiché.

export const estGroupe = (item) => Boolean(item) && Array.isArray(item.items);

export function construireMenu(items = [], groups = {}) {
  const simples = items.filter((item) => !item.group);
  const groupes = Object.values(groups).map((groupe) => ({
    ...groupe,
    items: items.filter((item) => item.group === groupe.id),
  }));
  return [...simples, ...groupes];
}

export function estMasque(item, user = {}, privilegesMasques = []) {
  if (typeof item.visibleIf === "function" && !item.visibleIf(user)) return true;
  return Boolean(item.dataPriv && privilegesMasques.includes(item.dataPriv));
}

// Arbre visible pour un utilisateur : entrées masquées retirées, groupes
// réduits à leurs entrées visibles, groupes vides retirés. L'ordre est conservé.
export function filtrerMenu(arbre, user, privilegesMasques) {
  return (arbre || []).reduce((visibles, item) => {
    if (estGroupe(item)) {
      const enfants = item.items.filter((it) => !estMasque(it, user, privilegesMasques));
      if (enfants.length) visibles.push({ ...item, items: enfants });
    } else if (!estMasque(item, user, privilegesMasques)) {
      visibles.push(item);
    }
    return visibles;
  }, []);
}

// Une route est active sur elle-même et sur ses sous-routes (`/users/12`),
// jamais sur une route voisine partageant le préfixe (`/leads` et `/leads-auto`).
export function estRouteActive(path, pathname) {
  if (!path || !pathname) return false;
  if (path === "/") return pathname === "/";
  return pathname === path || pathname.startsWith(path + "/");
}

// Une entrée peut déclarer des routes équivalentes (`alias`) : l'accueil est
// servi sur /dashboard et sur la racine.
export function estEntreeActive(item, pathname) {
  return [item.path, ...(item.alias || [])].some((path) => estRouteActive(path, pathname));
}

export function contientRoute(groupe, pathname) {
  return estGroupe(groupe) && groupe.items.some((it) => estEntreeActive(it, pathname));
}

// Nom du groupe contenant la route courante (null hors groupe).
export function groupeDeLaRoute(arbre, pathname) {
  const groupe = (arbre || []).find((item) => contientRoute(item, pathname));
  return groupe ? groupe.name : null;
}

// Entrée (ou sous-entrée) de la route courante : titre de la barre haute du
// tiroir.
export function entreeActive(arbre, pathname) {
  for (const item of arbre || []) {
    if (estGroupe(item)) {
      const enfant = item.items.find((it) => estEntreeActive(it, pathname));
      if (enfant) return enfant;
    } else if (estEntreeActive(item, pathname)) {
      return item;
    }
  }
  return null;
}
